export function liveValidateBlur(element: HTMLInputElement) {
    element.addEventListener('focus', function (this: HTMLInputElement, e: InputEvent) {
        element.form?.classList.add('focus-within');
    });
    element.addEventListener('blur', function (this: HTMLInputElement, e: InputEvent) {
        element.classList.add('focus-visible');
        element.form?.classList.remove('focus-within');
    });
}
